import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownTinhTrangGiaiQuyet extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if (this.props.data.length == 0) {
      DuLieuHeThong.actions.getTrangThaiDon.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'trangThaiDon',
            data: res.data || []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state});
    }
  }


  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown label={this.props.label} selectedValue={this.props.selectedValue} options={ this.state.data } keyName='giaTri' valueName='ten' className={this.props.className} onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } />
    );
  }
}

DropDownTinhTrangGiaiQuyet.defaultProps = {
  label: 'Tình trạng giải quyết',
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  options: [],
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.trangThaiDon
  }
}

export default connect(bindStateToProps)(DropDownTinhTrangGiaiQuyet);


// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-tinhtranggiaiquyet.jsx